module.exports = __webpack_public_path__ + "img/itemHeader.7d610130.png";